import {getFirestore} from 'firebase/firestore'
import {initializeApp} from 'firebase/app'
import { getAnalytics } from "firebase/analytics";
import {getAuth} from 'firebase/auth'
import {LocalSettingManager} from "biewangle";


const newFirebaseConfig = {
  apiKey: "AIzaSyDY7XCOI9aodCo0GCdazqX42TGGzrshDrM",
  authDomain: "aaden-saas.firebaseapp.com",
  projectId: "aaden-saas",
  storageBucket: "aaden-saas.appspot.com",
  messagingSenderId: "169167876904",
  appId: "1:169167876904:web:609e9da997b47165cc161d",
  measurementId: "G-E1BLCBZ879"
};


export const firebaseApp = initializeApp(newFirebaseConfig, 'firebaseApp')

export const FireBaseAuth = getAuth(firebaseApp)

export const analytics = getAnalytics(firebaseApp);
export const db = getFirestore(firebaseApp)

export const Remember = LocalSettingManager.config({
  orderId: "",
  takeawayMode: 1,
  sessionId: "",
  modeSelected: 0,
})
